import { useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { createUseStatementScreenProps } from '@/src/experiences/card-statements/Statement/createUseStatementScreenProps'
import { GENERATE_STATEMENT_PDF_LINK } from '@/src/common/gql/mutations/card'
import type { StatementComponent } from '@/src/experiences/card-statements/Statement/withStatementScreen'

const useLegacyStatementScreenProps = createUseStatementScreenProps((props) => {
  const [generateStatementPdfLink, { data, loading, error }] = useMutation(
    GENERATE_STATEMENT_PDF_LINK,
  )

  useEffect(() => {
    if (typeof props?.id === 'string')
      void generateStatementPdfLink({ variables: { statementId: props.id } })
  }, [generateStatementPdfLink, props?.id])

  return {
    pdfLink: data?.generateStatementPdfLink.url,
    loading,
    error,
  } as const
})

export const LegacyStatement: StatementComponent = ({ ToWrap, statementScreenParams }) => (
  <ToWrap statementScreenProps={useLegacyStatementScreenProps(statementScreenParams)} />
)
